import React, { useEffect, Fragment, useState } from 'react'

import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom'
import { configuracionFormAction9, obtenerCasoImplicado, obtenerDatosLlaves} from "../../store/actions/encargado-cia-action";
import LegalizacionForms from './LegalizacionForms'
import { obtenerForm10 } from '../../store/actions/legalizacion-pago-action'
import { Auth, LoadingComponent } from 'recupero-comunes'
import { CasoGeneralComponent } from 'reccol-caso-general'


const LegalizacionPagoRecobro = () => {
  
  const { rutUsuario, rutOrganizacion } = Auth.currentUser()
  const {state}=useLocation()
  // El hook useSelector (redux) permite acceder al state en nuestro store.

  const dispatch = useDispatch();
  const idCasoLocation=state?.row?.IdCaso ? state.row.IdCaso :9
  const idImplicado=state?.row?.IdImplicado ? state.row.IdImplicado :1
  const idOrganizacionCaso =state?.row?.idOrganizacionCaso  ? state.row.idOrganizacionCaso:8600399880
 
 
  
  
  return (
    <>
  
      <Container>
      <Container>
            <Card className='mt-2'>
                <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >
                  {`Legalizar Pago Recobro CIAS - Caso ${idCasoLocation}`}
                </Card.Header>
                <Card.Body>
                    <CasoGeneralComponent idCaso={idCasoLocation} idImplicado={idImplicado} idOrganizacionCaso={idOrganizacionCaso} /> 
             </Card.Body>
            </Card>
    
            <LegalizacionForms/>
            </Container> 
          
       
          </Container>
        
    </>
  )
}
export default LegalizacionPagoRecobro
